// The one frame type on both client sockets (SPEC §7.2). Field numbers are frozen once shipped.

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=none"
// @generated from file helm/v1/envelope.proto (package helm.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { DocChanged, Hello, LoginStatus, Notice, Ping, Pong, Resume, RithmicLogin, RithmicLogout, SessionState, SystemList, Welcome } from "./session_pb";
import { file_helm_v1_session } from "./session_pb";
import type { Bbo, BookDelta, BookUpdate, HistoryChunk, HistoryRequest, InstrumentInfo, MarketDataGap, SessionStats, Subscribe, SymbolSearch, SymbolSearchResult, TradeBatch, Unsubscribe } from "./market_data_pb";
import { file_helm_v1_market_data } from "./market_data_pb";
import type { AccountUpdate, CancelOrder, CommandResult, ExitAction, FillEvent, ForceExit, ModifyOrder, OrderEvent, PlaceOrder, PositionUpdate, Resync, SetPositionBracket } from "./trading_pb";
import { file_helm_v1_trading } from "./trading_pb";
import type { AlertFired, CopyCommand, CopyLogEntry, CopyState, IndicatorSubscribe, IndicatorValues, ManualLockout, ManualLockoutBatch, ManualLockoutBatchResult, ManualLockoutInventoryRequest, ManualLockoutInventoryResult, ManualLockoutResult, RiskEvent, RiskState, StrategyCommand, StrategyLog, StrategyPlot, StrategyState } from "./risk_pb";
import { file_helm_v1_risk } from "./risk_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file helm/v1/envelope.proto.
 */
export const file_helm_v1_envelope: GenFile = /*@__PURE__*/
  fileDesc("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", [file_helm_v1_session, file_helm_v1_market_data, file_helm_v1_trading, file_helm_v1_risk]);

/**
 * @generated from message helm.v1.Snapshot
 */
export type Snapshot = Message<"helm.v1.Snapshot"> & {
  /**
   * @generated from field: repeated helm.v1.AccountUpdate accounts = 1;
   */
  accounts: AccountUpdate[];

  /**
   * @generated from field: repeated helm.v1.OrderEvent orders = 2;
   */
  orders: OrderEvent[];

  /**
   * @generated from field: repeated helm.v1.PositionUpdate positions = 3;
   */
  positions: PositionUpdate[];

  /**
   * @generated from field: repeated helm.v1.RiskState risk = 4;
   */
  risk: RiskState[];

  /**
   * @generated from field: repeated helm.v1.CopyState copy = 5;
   */
  copy: CopyState[];

  /**
   * @generated from field: repeated helm.v1.StrategyState strategies = 6;
   */
  strategies: StrategyState[];

  /**
   * @generated from field: repeated helm.v1.SessionState sessions = 7;
   */
  sessions: SessionState[];

  /**
   * Accounts whose positions Rithmic has not confirmed (ADR-0032, audit AB-1), with the reason.
   * Authoritative only when `positions_checked` is set: the client then REPLACES its unconfirmed
   * flags with this list (an account not in it is confirmed). Unset (the order plant is not READY,
   * or no order routing), the client keeps its flags: a stale warning is the safe side.
   *
   * @generated from field: repeated helm.v1.UnconfirmedAccount unconfirmed = 8;
   */
  unconfirmed: UnconfirmedAccount[];

  /**
   * @generated from field: bool positions_checked = 9;
   */
  positionsChecked: boolean;

  /**
   * Accounts with an exit HELM is holding back past `flatten_pending_for` because a protective
   * order's cancel is unconfirmed (ADR-0050): the Error `FLATTEN_WAITING` banner with its Force
   * button. Authoritative for the snapshot's accounts when `positions_checked` is set (the client
   * replaces those accounts' flags; `FLATTEN_WAITING_CLEARED` clears one live).
   *
   * @generated from field: repeated helm.v1.HeldExit held_exits = 10;
   */
  heldExits: HeldExit[];
};

/**
 * Describes the message helm.v1.Snapshot.
 * Use `create(SnapshotSchema)` to create a new message.
 */
export const SnapshotSchema: GenMessage<Snapshot> = /*@__PURE__*/
  messageDesc(file_helm_v1_envelope, 0);

/**
 * One account's held exit (ADR-0050), with the text of its `FLATTEN_WAITING` notice.
 *
 * @generated from message helm.v1.HeldExit
 */
export type HeldExit = Message<"helm.v1.HeldExit"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;
};

/**
 * Describes the message helm.v1.HeldExit.
 * Use `create(HeldExitSchema)` to create a new message.
 */
export const HeldExitSchema: GenMessage<HeldExit> = /*@__PURE__*/
  messageDesc(file_helm_v1_envelope, 1);

/**
 * One account whose positions are not confirmed by Rithmic, and why (shown in the banner).
 *
 * @generated from message helm.v1.UnconfirmedAccount
 */
export type UnconfirmedAccount = Message<"helm.v1.UnconfirmedAccount"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message helm.v1.UnconfirmedAccount.
 * Use `create(UnconfirmedAccountSchema)` to create a new message.
 */
export const UnconfirmedAccountSchema: GenMessage<UnconfirmedAccount> = /*@__PURE__*/
  messageDesc(file_helm_v1_envelope, 2);

/**
 * @generated from message helm.v1.Envelope
 */
export type Envelope = Message<"helm.v1.Envelope"> & {
  /**
   * gateway->client: monotonic per session for ordered events; 0 for market data
   *
   * @generated from field: uint64 seq = 1;
   */
  seq: bigint;

  /**
   * client-generated for requests; echoed on the response
   *
   * @generated from field: string req_id = 2;
   */
  reqId: string;

  /**
   * @generated from oneof helm.v1.Envelope.body
   */
  body: {
    /**
     * --- session ---
     *
     * @generated from field: helm.v1.Hello hello = 10;
     */
    value: Hello;
    case: "hello";
  } | {
    /**
     * @generated from field: helm.v1.Welcome welcome = 11;
     */
    value: Welcome;
    case: "welcome";
  } | {
    /**
     * @generated from field: helm.v1.Ping ping = 12;
     */
    value: Ping;
    case: "ping";
  } | {
    /**
     * @generated from field: helm.v1.Pong pong = 13;
     */
    value: Pong;
    case: "pong";
  } | {
    /**
     * @generated from field: helm.v1.Resume resume = 14;
     */
    value: Resume;
    case: "resume";
  } | {
    /**
     * @generated from field: helm.v1.RithmicLogin rithmic_login = 20;
     */
    value: RithmicLogin;
    case: "rithmicLogin";
  } | {
    /**
     * @generated from field: helm.v1.SessionState session_state = 21;
     */
    value: SessionState;
    case: "sessionState";
  } | {
    /**
     * @generated from field: helm.v1.SystemList system_list = 22;
     */
    value: SystemList;
    case: "systemList";
  } | {
    /**
     * @generated from field: helm.v1.DocChanged doc_changed = 23;
     */
    value: DocChanged;
    case: "docChanged";
  } | {
    /**
     * @generated from field: helm.v1.RithmicLogout rithmic_logout = 24;
     */
    value: RithmicLogout;
    case: "rithmicLogout";
  } | {
    /**
     * @generated from field: helm.v1.LoginStatus login_status = 25;
     */
    value: LoginStatus;
    case: "loginStatus";
  } | {
    /**
     * --- market data ---
     *
     * @generated from field: helm.v1.Subscribe subscribe = 30;
     */
    value: Subscribe;
    case: "subscribe";
  } | {
    /**
     * @generated from field: helm.v1.Unsubscribe unsubscribe = 31;
     */
    value: Unsubscribe;
    case: "unsubscribe";
  } | {
    /**
     * @generated from field: helm.v1.TradeBatch trades = 32;
     */
    value: TradeBatch;
    case: "trades";
  } | {
    /**
     * @generated from field: helm.v1.BookUpdate book = 33;
     */
    value: BookUpdate;
    case: "book";
  } | {
    /**
     * @generated from field: helm.v1.Bbo bbo = 34;
     */
    value: Bbo;
    case: "bbo";
  } | {
    /**
     * @generated from field: helm.v1.SessionStats stats = 35;
     */
    value: SessionStats;
    case: "stats";
  } | {
    /**
     * @generated from field: helm.v1.HistoryRequest history_req = 36;
     */
    value: HistoryRequest;
    case: "historyReq";
  } | {
    /**
     * @generated from field: helm.v1.HistoryChunk history_chunk = 37;
     */
    value: HistoryChunk;
    case: "historyChunk";
  } | {
    /**
     * @generated from field: helm.v1.SymbolSearch symbol_search = 38;
     */
    value: SymbolSearch;
    case: "symbolSearch";
  } | {
    /**
     * @generated from field: helm.v1.SymbolSearchResult symbol_result = 39;
     */
    value: SymbolSearchResult;
    case: "symbolResult";
  } | {
    /**
     * @generated from field: helm.v1.InstrumentInfo instrument = 40;
     */
    value: InstrumentInfo;
    case: "instrument";
  } | {
    /**
     * @generated from field: helm.v1.BookDelta book_delta = 41;
     */
    value: BookDelta;
    case: "bookDelta";
  } | {
    /**
     * @generated from field: helm.v1.MarketDataGap md_gap = 42;
     */
    value: MarketDataGap;
    case: "mdGap";
  } | {
    /**
     * --- trading ---
     *
     * @generated from field: helm.v1.PlaceOrder place = 50;
     */
    value: PlaceOrder;
    case: "place";
  } | {
    /**
     * @generated from field: helm.v1.ModifyOrder modify = 51;
     */
    value: ModifyOrder;
    case: "modify";
  } | {
    /**
     * @generated from field: helm.v1.CancelOrder cancel = 52;
     */
    value: CancelOrder;
    case: "cancel";
  } | {
    /**
     * @generated from field: helm.v1.ExitAction exit_action = 53;
     */
    value: ExitAction;
    case: "exitAction";
  } | {
    /**
     * @generated from field: helm.v1.SetPositionBracket set_pos_bracket = 54;
     */
    value: SetPositionBracket;
    case: "setPosBracket";
  } | {
    /**
     * @generated from field: helm.v1.OrderEvent order_event = 55;
     */
    value: OrderEvent;
    case: "orderEvent";
  } | {
    /**
     * @generated from field: helm.v1.FillEvent fill = 56;
     */
    value: FillEvent;
    case: "fill";
  } | {
    /**
     * @generated from field: helm.v1.PositionUpdate position = 57;
     */
    value: PositionUpdate;
    case: "position";
  } | {
    /**
     * @generated from field: helm.v1.AccountUpdate account = 58;
     */
    value: AccountUpdate;
    case: "account";
  } | {
    /**
     * @generated from field: helm.v1.CommandResult result = 59;
     */
    value: CommandResult;
    case: "result";
  } | {
    /**
     * @generated from field: helm.v1.ForceExit force_exit = 60;
     */
    value: ForceExit;
    case: "forceExit";
  } | {
    /**
     * @generated from field: helm.v1.Resync resync = 61;
     */
    value: Resync;
    case: "resync";
  } | {
    /**
     * --- risk / copy / alerts / strategies ---
     *
     * @generated from field: helm.v1.RiskState risk_state = 70;
     */
    value: RiskState;
    case: "riskState";
  } | {
    /**
     * @generated from field: helm.v1.RiskEvent risk_event = 71;
     */
    value: RiskEvent;
    case: "riskEvent";
  } | {
    /**
     * @generated from field: helm.v1.CopyState copy_state = 72;
     */
    value: CopyState;
    case: "copyState";
  } | {
    /**
     * @generated from field: helm.v1.AlertFired alert = 73;
     */
    value: AlertFired;
    case: "alert";
  } | {
    /**
     * @generated from field: helm.v1.StrategyState strategy_state = 74;
     */
    value: StrategyState;
    case: "strategyState";
  } | {
    /**
     * @generated from field: helm.v1.StrategyLog strategy_log = 75;
     */
    value: StrategyLog;
    case: "strategyLog";
  } | {
    /**
     * @generated from field: helm.v1.StrategyPlot strategy_plot = 76;
     */
    value: StrategyPlot;
    case: "strategyPlot";
  } | {
    /**
     * @generated from field: helm.v1.StrategyCommand strategy_cmd = 77;
     */
    value: StrategyCommand;
    case: "strategyCmd";
  } | {
    /**
     * @generated from field: helm.v1.IndicatorSubscribe ind_sub = 78;
     */
    value: IndicatorSubscribe;
    case: "indSub";
  } | {
    /**
     * @generated from field: helm.v1.IndicatorValues ind_values = 79;
     */
    value: IndicatorValues;
    case: "indValues";
  } | {
    /**
     * @generated from field: helm.v1.CopyLogEntry copy_log = 80;
     */
    value: CopyLogEntry;
    case: "copyLog";
  } | {
    /**
     * @generated from field: helm.v1.CopyCommand copy_cmd = 81;
     */
    value: CopyCommand;
    case: "copyCmd";
  } | {
    /**
     * @generated from field: helm.v1.ManualLockout manual_lockout = 82;
     */
    value: ManualLockout;
    case: "manualLockout";
  } | {
    /**
     * @generated from field: helm.v1.ManualLockoutResult manual_lockout_result = 83;
     */
    value: ManualLockoutResult;
    case: "manualLockoutResult";
  } | {
    /**
     * @generated from field: helm.v1.ManualLockoutInventoryRequest manual_lockout_inventory_request = 84;
     */
    value: ManualLockoutInventoryRequest;
    case: "manualLockoutInventoryRequest";
  } | {
    /**
     * @generated from field: helm.v1.ManualLockoutInventoryResult manual_lockout_inventory_result = 85;
     */
    value: ManualLockoutInventoryResult;
    case: "manualLockoutInventoryResult";
  } | {
    /**
     * @generated from field: helm.v1.ManualLockoutBatch manual_lockout_batch = 86;
     */
    value: ManualLockoutBatch;
    case: "manualLockoutBatch";
  } | {
    /**
     * @generated from field: helm.v1.ManualLockoutBatchResult manual_lockout_batch_result = 87;
     */
    value: ManualLockoutBatchResult;
    case: "manualLockoutBatchResult";
  } | {
    /**
     * --- snapshots ---
     *
     * @generated from field: helm.v1.Snapshot snapshot = 90;
     */
    value: Snapshot;
    case: "snapshot";
  } | {
    /**
     * @generated from field: helm.v1.Notice notice = 99;
     */
    value: Notice;
    case: "notice";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message helm.v1.Envelope.
 * Use `create(EnvelopeSchema)` to create a new message.
 */
export const EnvelopeSchema: GenMessage<Envelope> = /*@__PURE__*/
  messageDesc(file_helm_v1_envelope, 3);

